// Legacy agents-list URL — the Agents page moved to the unified `/agents`
// cluster (agents + skills + memories) in the 2026-07 nav review.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../../lib/constants';

export const Route = createFileRoute('/workflows/agents/')({
  beforeLoad: () => {
    throw redirect({ to: routes.AGENTS, replace: true });
  },
  component: () => null,
});
